/**
 * Validation utility functions
 */

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validateUsername(username: string): { valid: boolean; error?: string } {
  if (username.length < 3) {
    return { valid: false, error: 'Username must be at least 3 characters' };
  }
  if (username.length > 50) {
    return { valid: false, error: 'Username must be less than 50 characters' };
  }
  if (!/^[a-zA-Z0-9_]+$/.test(username)) {
    return { valid: false, error: 'Username must contain only alphanumeric characters and underscores' };
  }
  return { valid: true };
}

export function validatePassword(password: string): { valid: boolean; error?: string } {
  if (password.length < 12) {
    return { valid: false, error: 'Password must be at least 12 characters' };
  }
  return { valid: true };
}

export function validateSSHKey(publicKey: string): { valid: boolean; error?: string; keyType?: string } {
  const trimmedKey = publicKey.trim();
  
  if (!trimmedKey) {
    return { valid: false, error: 'SSH key cannot be empty' };
  }

  // Check for valid SSH key format
  const sshKeyRegex = /^(ssh-rsa|ssh-ed25519|ecdsa-sha2-nistp256|ecdsa-sha2-nistp384|ecdsa-sha2-nistp521)\s+[A-Za-z0-9+/]+=*(\s+.*)?$/;
  
  if (!sshKeyRegex.test(trimmedKey)) {
    return { valid: false, error: 'Invalid SSH key format. Must be a valid OpenSSH public key.' };
  }

  // Extract key type
  const keyType = trimmedKey.split(' ')[0].replace('ssh-', '');
  
  return { valid: true, keyType };
}

export function validateSSHKeyName(name: string): { valid: boolean; error?: string } {
  const trimmedName = name.trim();
  
  if (!trimmedName) {
    return { valid: false, error: 'SSH key name cannot be empty' };
  }
  
  if (trimmedName.length > 100) {
    return { valid: false, error: 'SSH key name must be less than 100 characters' };
  }
  
  return { valid: true };
}

export function validateTTLExtension(hours: number): { valid: boolean; error?: string } {
  if (hours < 1) {
    return { valid: false, error: 'Extension must be at least 1 hour' };
  }
  
  if (hours > 24) {
    return { valid: false, error: 'Extension cannot exceed 24 hours' };
  }
  
  if (hours % 1 !== 0) {
    return { valid: false, error: 'Extension must be a whole number of hours' };
  }
  
  return { valid: true };
}